<template>
  <div id="contenuAdmin">
    <div id="menuAdmin">
      <MenuAdmin id="menuTop"/>
    </div>
    <div id="main">
      <component :is="layout"></component>
    </div>
  </div>
</template>
<script>
import script from '../../script/script.js';
import MenuAdmin from './MenuAdmin.vue';
export default {
  data() {
    return {
    }
  },
  mounted:function(){
     this.verifyRight();
  },
  methods: {
	verifyRight: script.verifyRight,
  },
  components: {
    MenuAdmin
  },
  computed:{
    layout(){
      return(this.$route.meta.layout)+'-layout';
    }
  }
  
}
</script>
<style>
#contenuAdmin {
  display: flex;
  height: 100vh;
}

#menuAdmin {
  flex: 0 0 auto;
  width: 200px;
}

#main {
  flex: 1;
  overflow-y: auto;
  position: relative;
}

</style>
